module.exports = __webpack_public_path__ + "static/img/img_awards_5en.342cf8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/img_awards_5en.png
// module id = VKC5
// module chunks = 15